import { render } from "./previewPage.vue?vue&type=template&id=74b01abd&scoped=true"
import script from "./previewPage.vue?vue&type=script&lang=js"
export * from "./previewPage.vue?vue&type=script&lang=js"

import "./previewPage.vue?vue&type=style&index=0&id=74b01abd&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b01abd"]])

export default __exports__